import { jsx as _jsx } from "react/jsx-runtime";
import { useSignal, useSignalEffect } from "@preact/signals";
import asArray from "../../../lib/as-array";
import TextInput from "../../Form/TextInput";
import FilterPill from "../FilterPill";
import layout from "../../Layout/style.module.scss";
export default function TextFilter(props) {
    const { name, disabled, removable, open, onChange, onRemove } = props;
    const options = props.options.map((option) => option.value);
    const selected = useSignal(props.defaultValue || { label: "", value: "" });
    // Call onChange when the selected value changes
    useSignalEffect(() => {
        if (onChange) {
            onChange(selected.value);
        }
    });
    return (_jsx(FilterPill, { attributes: props.attributes, name: name, options: selected.value.value ? asArray(selected.value) : [], open: open, disabled: disabled, removable: removable, onRemove: onRemove, children: _jsx("div", { className: layout["padding"], children: _jsx(TextInput, { defaultValue: selected.value.value, disabled: disabled, onInput: (event) => {
                    const value = event.currentTarget.value;
                    selected.value = { value, label: value };
                }, typeAheadOptions: options }) }) }));
}
